
import { PersonalityType } from './types';
import { Feather, Mountain, Lightbulb, Sprout } from 'lucide-react';
import React from 'react';

export const PERSONALITY_CONFIG = {
  [PersonalityType.BUTTERFLY]: {
    id: PersonalityType.BUTTERFLY,
    labelKey: 'personality_butterfly',
    descKey: 'personality_butterfly_desc',
    detailsKey: 'personality_butterfly_details',
    icon: <Feather className="w-8 h-8" />,
    color: 'text-pink-500',
    bg: 'bg-pink-100',
    border: 'border-pink-200',
    themeColor: '#ec4899'
  },
  [PersonalityType.MOUNTAIN]: {
    id: PersonalityType.MOUNTAIN,
    labelKey: 'personality_mountain',
    descKey: 'personality_mountain_desc',
    detailsKey: 'personality_mountain_details',
    icon: <Mountain className="w-8 h-8" />,
    color: 'text-slate-600',
    bg: 'bg-slate-200',
    border: 'border-slate-300',
    themeColor: '#475569'
  },
  [PersonalityType.LAMP]: {
    id: PersonalityType.LAMP,
    labelKey: 'personality_lamp',
    descKey: 'personality_lamp_desc',
    detailsKey: 'personality_lamp_details',
    icon: <Lightbulb className="w-8 h-8" />,
    color: 'text-amber-500',
    bg: 'bg-amber-100',
    border: 'border-amber-200',
    themeColor: '#f59e0b'
  },
  [PersonalityType.GARDENER]: {
    id: PersonalityType.GARDENER,
    labelKey: 'personality_gardener',
    descKey: 'personality_gardener_desc',
    detailsKey: 'personality_gardener_details',
    icon: <Sprout className="w-8 h-8" />,
    color: 'text-emerald-500',
    bg: 'bg-emerald-100',
    border: 'border-emerald-200',
    themeColor: '#10b981'
  }
};

export const MOCK_EVENTS = [
  { id: '1', title: 'شروع سفر با همراه', date: '۱۴۰۲/۱۰/۰۱', type: 'memory', description: 'اولین روز آشنایی ما.' },
  { id: '2', title: 'تکمیل پروفایل سلامتی', date: '۱۴۰۲/۱۰/۵', type: 'achievement', description: 'اولین قدم برای سلامتی برداشته شد.' },
  { id: '3', title: 'کاهش استرس شغلی', date: '۱۴۰۲/۱۰/۱۲', type: 'insight', description: 'یاد گرفتیم که استراحت کوتاه چقدر موثر است.' },
] as const;
